import React from 'react';
import { Card, Button, Icon } from 'antd';
import { IProps, INotifyInfo } from '../../../domain/model';
import './contractUpdateGuide.css';

/* eslint-disable react/no-unescaped-entities */
export default function ContractUpdateGuide({ state }: IProps): JSX.Element {
  /**
   * 契約変更ガイドの表示要否を判定する。
   * @returns true: 対象サービスが契約期間内（isOutOfRangeがfalse）、かつ新価格適用済み（isNewPriceAppriedがtrue）の場合
   * false: 契約期間外の場合（次年度更新済かどうかに関わらずガイドを表示しない）
   */
  const isVisible = state.notifyInfo.some((notification: INotifyInfo) => {
    return !notification.isOutOfRange && notification.isNewPriceAppried;
  });

  // 契約変更 専用申込フォームのURL（次年度更新用フォームとは別）
  const contractChangeFormUrl = process.env.REACT_APP_CONTRACT_UPDATE_FORM_URL;

  // 契約変更 専用申込フォームのお申込み方法マニュアルのURL
  const contractChangeFormManualUrl = process.env.REACT_APP_CONTRACT_UPDATE_FORM_MANUAL_URL;

  return (
    <div className="priceRevisionGuide contractUpdateGuide" hidden={!isVisible}>
      <Card bordered={false}>
        <p className="guideTitle">【重要】契約変更のお申込み方法について</p>
        <p>
          2027年4月1日より、料金を改定いたします。
          <br />
          料金改定に伴うシステム対応のため、契約変更のお申込み方法は、ご利用期間によって異なります。
        </p>
        <p className="guideSubTitle">2027年4月以降のご利用分を含まない場合</p>
        <p>これまでどおり、「変更申込はこちら」ボタンよりお手続きください。</p>
        <p className="guideSubTitle">2027年4月以降のご利用分を含む場合</p>
        <p>以下の専用申込フォームよりお手続きくださいますようお願いいたします。</p>
        <Button type="primary" className="guideFormBtn" href={contractChangeFormUrl} target="_blank" rel="noopener noreferrer">
          契約変更 専用申込フォームはこちら
          <Icon style={{ fontSize: '18px' }} type="play-circle" />
        </Button>
        <p className="guideSubTitle">お手続きの流れ</p>
        <ol>
          <li>上記ボタンをクリック後、「メールアドレスでログイン」をクリックしてください。</li>
          <li>入力欄が表示されますので、企業担当者様のメールアドレスを入力し、「送信する」ボタンをクリックしてください。</li>
          <li>ご入力のアドレス宛に、件名『【トヨクモ kintone 連携サービス】ログイン用メール』が届きます。</li>
          <li>
            メール内のリンクから申込フォームを開き、必要事項を入力のうえ送信してください。
            <br />
            （⚠ メールが届かない場合は、送信元アドレス「noreply@kintoneapp.com」からのメールが受信可能な設定になっているか、ご確認ください）
          </li>
          <li>弊社にてお申込み内容を確認いたします。</li>
          <li>ご請求書およびお見積書の作成完了後、企業担当者様のメールアドレス宛に完了のご案内をお送りします。</li>
          <li>ご請求書およびお見積書は、これまでどおり本画面よりダウンロードしてください。</li>
        </ol>
        <p className="noticeManual">
          お申込み方法については以下マニュアルをご参照ください。
          <br />
          <a className="noticeManualLink" href={contractChangeFormManualUrl} target="_blank" rel="noopener noreferrer">
            申込マニュアルはこちら
            <Icon className="noticeManualIcon" type="select" />
          </a>
        </p>
        <p className="guideNote">
          ※ご請求書の作成には、通常3営業日程度かかります。
          <br />
          ※お申込み内容や受付状況により、作成までの日数が前後する場合がございます。あらかじめご了承ください。
          <br />
          <span className="guideNoteWarning">※メールに記載されたURLは誤って他社に転送しないようご注意ください。</span>
        </p>
      </Card>
    </div>
  );
}
